import { Input } from "antd";
import React from "react";

function CustomInput(props) {
  const {
    placeholder,
    value,
    className,
    type,
    name,
    id,
    required,
    handleChange,
    defaultValue,
    reference,
    label,
    labelClasses,
    allowClear,
  } = props;
  return (
    <>
      {label && (
        <label className={labelClasses}>
          {label}
          {required && <span className="text-red-500"> *</span>}
        </label>
      )}
      <Input
        className={`${className} w-full`}
        type={type}
        name={name}
        id={id}
        required={required}
        placeholder={placeholder}
        value={value || defaultValue}
        onChange={e => (handleChange ? handleChange(e) : {})}
        defaultValue={defaultValue}
        ref={reference}
        allowClear={allowClear}
      />
    </>
  );
}

CustomInput.defaultProsp = {
  type: "text",
  required: false,
  handleChange: () => {},
  placeholder: "Enter Value",
  defaultValue: "",
  allowClear: false,
};

export default CustomInput;
